import { componentStylesToCss } from '../componentStylesUtils';

const stylesTextHref = (componentStyles) => `
  .textHref-wrapper {
    ${componentStylesToCss(componentStyles?.wrapper)}
  }
`;

export default stylesTextHref;
